import React from "react"
import { InputWithLabel } from "./common"
import { formatPhone } from "../userDetailsUtilities"

const Phone = ({ dirty, edit, phone, onFocus, onBlur, onChangeInput }) => (
  <InputWithLabel
    isEditing={dirty}
    edit={edit}
    label="Phone"
    showError={phone.edited && !phone.valid && !phone.isActive}
    error={phone.error}
    onFocus={onFocus("phone")}
    onBlur={onBlur("phone")}
    fieldType="tel"
    onChange={onChangeInput("phone")}
    value={formatPhone(phone.value)}
    required
  />
)

export { Phone as default }



// WEBPACK FOOTER //
// ./assets/account/components/forms/Phone.js